const bulkOrderModule = {
    namespaced: true,
    persistent: true,
    state: {
        data: {}
    },
    getters: {
        getData: state => {
            return state.data;
        },
        getBulkOrders: state => userId => {
            return state.data[userId];
        }
    },
    mutations: {
        addOrderToBulkOrders (state, payload) {
            let userId = payload.userId;
            let warehouseId = payload.warehouseId;

            if (!state.data[userId]) {
                state.data[userId] = {};
            }

            if (!state.data[userId][warehouseId]) {
                state.data[userId][warehouseId] = [];
            }

            state.data[userId][warehouseId].push({
                'order': payload.order,
                'recipients': payload.recipients,
                'message': payload.message
            });
        },
        removeOrderFromBulkOrders (state, payload) {
            let userId = payload.userId;
            let warehouseId = payload.warehouseId;

            if (!state.data[userId]) {
                state.data[userId] = {};
            }

            if (!state.data[userId][warehouseId]) {
                state.data[userId][warehouseId] = [];
            }

            const index = state.data[userId][warehouseId].indexOf(payload.item);
            state.data[userId][warehouseId].splice(index, 1);
        },
        removeOrdersFromBulkOrders (state, payload) {
            let userId = payload.userId;
            let warehouseId = payload.warehouseId;

            if (!state.data[userId]) {
                state.data[userId] = {};
            }

            state.data[userId][warehouseId] = [];
        },
        reset (state) {
            state.data = {};
        }
    }
};

export default bulkOrderModule;
